<template>
  <v-row>
    <v-col cols="12">
      <p class="primary--text mb-5 list-modality__title">
        SEGURADORA: {{ insurance.nome }}
      </p>
      <p class="form__title gray--text mb-3">
        MODALIDADES
      </p>
    </v-col>
    <v-col
      v-for="(item, key) of listActiveModality"
      :key="key"
      cols="12"
      sm="5"
      md="3"
      class="pr-5 pb-5 d-flex justify-center justify-sm-start"
    >
      <QuotationCard
        @click="selectedItem(item)"
        :name="item.nome"
        :background="item.imagem"
        :class="{ 'base-card-active': findActiveItem(item) }"
      />
    </v-col>
  </v-row>
</template>
<script>
import CardDescriptionButton from "@/components/CardDescriptionButton.vue";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { InsuranceCompanyMixin } from "@/mixins/NewInsuranceCompanyMixin";
import _ from "lodash";
export default {
  data: () => ({
    list: [],
    model: {}
  }),
  components: {
    QuotationCard: CardDescriptionButton
  },
  mixins: [LoadingRequest, InsuranceCompanyMixin],
  created() {
    this.fetchModality();
  },
  computed: {
    ...mapState("quotation", ["listModality"]),
    listActiveModality() {
      const removeItems = this.modality.modalidades.filter(
        x => x.modalidade.id != this.form.id
      );
      return this.listModality.filter(
        x =>
          x.ativo == true && _.findIndex(removeItems, { modalidade: x }) == -1
      );
    },
    modalityStep() {
      return {
        name: "insurance_company step modality",
        step: 2
      };
    },
    editModality() {
      return {
        name: "insurance_company edit modality",
        step: 2
      };
    }
  },
  methods: {
    ...mapActions("quotation", ["requestModalities"]),
    fetchModality() {
      this.model = this.form;
      this.withLoading(this.requestModalities());
    },
    selectedItem(item) {
      this.model = item;
      this.$emit(
        "newModality",
        this.payloadInsuranceCompany(this.model, this.editModality)
      );
    },
    findActiveItem(item) {
      return this.model ? item.id === this.model.id : false;
    }
  },
  props: {
    return: {
      type: Boolean
    },
    insurance: {
      type: Object
    },
    form: {
      type: Object
    },
    modality: {
      type: Object
    }
  },
  watch: {
    return(value) {
      if (value)
        this.$emit(
          "updateStep",
          this.payloadInsuranceCompany(this.model, this.modalityStep)
        );
    }
  }
};
</script>
<style lang="sass">
.list-modality__title
  font-weight: 800
  font-size: 18px
</style>
